import { Typography } from '@material-ui/core';
import React, { ReactNode, Dispatch } from 'react';
import { WelcomeNavigationBar } from '../welcome-navigation-bar';
import {getJourneyId, getJourneyType, getCurrentIndex, getNextWelcomeUrl, getJourneyIdFromDraft } from '../../../utils/fenergo-utils';
import ROUTES from '../../../utils/routes';
import { useEntityState } from '../../../stores/entity/entity.hooks';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { setSnackBar } from '../../../stores/ui/ui-action';
import { useDispatch } from 'react-redux';

interface WelcomeFooterWrapperProps {
  children?: any;
  className?: string;
  proTipIcon: string;
  proTipLabel: string;
  proTipDescription: ReactNode;
  buttonLabel: string;
  hideBackButton?: boolean;
  disabled?: boolean;
  onNextClick?: () => void;
}

export const WelcomeFooterWrapper: React.FC<WelcomeFooterWrapperProps> = ({ children, ...props }) => {
  const {
    className,
    proTipIcon,
    proTipLabel,
    proTipDescription,
    buttonLabel,
    hideBackButton = false,
    disabled = false,
    onNextClick,
  } = props;
  const dispatch: Dispatch<any> = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedEntity, selectedJourneyTask, entityDraft } = useEntityState();

  const getCurrentPath = () => {
    return location.pathname.substring(location.pathname.lastIndexOf('/'))
  }
 const nextStep = async () => {
    try {
      if(onNextClick) {
        await onNextClick()
      }
      let nextIndex = getCurrentIndex(selectedEntity,getCurrentPath())+1;
      const journeyId = entityDraft ? getJourneyIdFromDraft(entityDraft) : getJourneyId(selectedEntity);

      getNextWelcomeUrl(selectedEntity,nextIndex)?
        navigate(getNextWelcomeUrl(selectedEntity,nextIndex)):
        navigate(`/journey/${journeyId}/task/${selectedJourneyTask.id}`);
    } catch (error) {
      dispatch(setSnackBar({ show: true, message: 'Error while calling API', description: error.message, messageType: 'error' })); 
    }
  }

return (
    <>
      <div className={className}>
        <div className="pro_tip_wrapper">
          <div className="pro_tp_icon">
            <img src={proTipIcon} alt="" draggable="false" />
          </div>
          <div className="pro_tip_section">
            <span className="pro_tip_label">{proTipLabel}</span>
            <Typography variant="body1">
              {proTipDescription}
            </Typography>
          </div>
        </div>
        <WelcomeNavigationBar
          buttonLabel={buttonLabel}
          onNext={nextStep}
          hideBackButton={hideBackButton}
          disabled={disabled} />
      </div>
    </>
  );
};
